export const getCodePushId = () => ''
